import { StoryblokRichTextNode } from "@storyblok/react/rsc";
import { default as React, ReactElement } from "react";
import { Link } from "@repo/ui-parkmobile/Link";
import { multilinkResolver } from "@/lib/storyblok/adaptors";
import type { Multilink } from "@/generated/sb";

export type LinkRichTextProps = {
  blok: StoryblokRichTextNode<ReactElement>;
  className?: string;
};

export function LinkRichText({ blok, className }: LinkRichTextProps) {
  if (!blok.text) return null;

  const attrs = blok.attrs as Multilink & {
    custom?: { nofollow?: string };
  };
  const noFollow = attrs?.custom?.nofollow === "true";
  const linkProps = multilinkResolver(attrs);

  if (!linkProps) return null;

  return (
    <Link {...linkProps} noFollow={linkProps.noFollow || noFollow} className={className}>
      {blok.text}
    </Link>
  );
}
